module.exports = __webpack_public_path__ + "static/img/91.a3eb5fb4.png";